export enum BulkUploadContentTypeEnum {
    CSDRMetadataSheet = 'CSDRMetadataSheet',
    VivliMetadataSheet = 'VivliMetadataSheet',
    IdsOnlySheet = 'IdsOnlySheet',
}
